import React from 'react';

import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import { ConfigProvider } from 'antd';
import frFR from 'antd/es/locale/fr_FR';

import TagManager from 'react-gtm-module';

import MRClient from './vendor/mr-client.min';
import {
  ClientProvider,
  ChatClientProvider,
  UserProvider,
  ChatUserProvider,
  RolesProvider,
} from './contexts';
import { EventParticipantsProvider } from './features/App/contexts/EventParticipantsContext';

import App from './features/App/App';

import { GTM_ID } from './constants';

import './index.css';
import * as serviceWorker from './serviceWorker';
import { loadScript } from './loadScript';

// Initialize MRClient SDK
const mrClient = new MRClient({
  apiUrl: process.env.REACT_APP_MR_CLIENT_API_URL,
  clientId: process.env.REACT_APP_MR_CLIENT_ID,
  clientSecret: process.env.REACT_APP_MR_CLIENT_SECRET,
});

TagManager.initialize({ gtmId: GTM_ID });

loadScript(
  `https://maps.googleapis.com/maps/api/js?libraries=places&callback=initMap&key=${process.env.REACT_APP_MAP_API_KEY}`,
  'google'
);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ConfigProvider locale={frFR}>
    <ClientProvider client={mrClient}>
      <ChatClientProvider>
        <UserProvider>
          <ChatUserProvider>
            <EventParticipantsProvider>
              <RolesProvider>
                <Router>
                  <App />
                </Router>
              </RolesProvider>
            </EventParticipantsProvider>
          </ChatUserProvider>
        </UserProvider>
      </ChatClientProvider>
    </ClientProvider>
  </ConfigProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
